import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoPendingSubject = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--background-complete--inject-2",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					y: 382.4,
					width: 500,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 416.78,
					y: 398.49,
					width: 33.12,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 322.53,
					y: 401.21,
					width: 8.69,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 396.59,
					y: 389.21,
					width: 19.19,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 52.46,
					y: 390.89,
					width: 43.19,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 104.56,
					y: 390.89,
					width: 6.33,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 131.47,
					y: 395.11,
					width: 93.68,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 179.22,
					y: 81.69,
					width: 254.12,
					height: 136.52,
					transform: "translate(612.56 299.91) rotate(180)",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 172.8,
					y: 81.69,
					width: 257.54,
					height: 136.52,
					transform: "translate(603.14 299.91) rotate(180)",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 179.22,
					y: 218.21,
					width: 254.12,
					height: 4.62,
					transform: "translate(612.56 441.05) rotate(180)",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 162.11,
					y: 218.21,
					width: 257.54,
					height: 4.62,
					transform: "translate(581.75 441.05) rotate(180)",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 242.3,
					y: 30.17,
					width: 118.54,
					height: 239.57,
					transform: "translate(451.52 -151.62) rotate(90)",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "393.64 209.23 340.89 90.68 286.92 90.68 339.66 209.23 393.64 209.23",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M417.19,189.42a.65.65,0,0,0,.65-.65V96.53a.65.65,0,0,0-1.29,0v92.24A.65.65,0,0,0,417.19,189.42Z",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "319.37 209.23 266.62 90.68 247.95 90.68 300.69 209.23 319.37 209.23",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 123.09,
					y: 149.38,
					width: 118.54,
					height: 1.14,
					transform: "translate(332.31 -32.4) rotate(90)",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .5 },
					children: [
						/* @__PURE__ */ _jsx("polygon", {
							points: "170.67 103.03 424.79 103.03 425.62 94.17 171.5 94.17 170.67 103.03",
							style: { fill: "#e6e6e6" }
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "170.67 117.64 424.79 117.64 425.62 108.79 171.5 108.79 170.67 117.64",
							style: { fill: "#e6e6e6" }
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "170.67 132.26 424.79 132.26 425.62 123.41 171.5 123.41 170.67 132.26",
							style: { fill: "#e6e6e6" }
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "170.67 146.87 424.79 146.87 425.62 138.02 171.5 138.02 170.67 146.87",
							style: { fill: "#e6e6e6" }
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "170.67 161.49 424.79 161.49 425.62 152.64 171.5 152.64 170.67 161.49",
							style: { fill: "#e6e6e6" }
						}),
						/* @__PURE__ */ _jsx("polygon", {
							points: "170.67 176.1 424.79 176.1 425.62 167.25 171.5 167.25 170.67 176.1",
							style: { fill: "#e6e6e6" }
						})
					]
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 398.13,
					y: 254.01,
					width: 30.89,
					height: 122.6,
					transform: "translate(827.16 630.62) rotate(180)",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 80.96,
					y: 376.61,
					width: 342.13,
					height: 5.79,
					transform: "translate(504.05 759.01) rotate(180)",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 75.03,
					y: 254.01,
					width: 323.1,
					height: 122.6,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M386,331.39H87.18a1.11,1.11,0,0,1-1.11-1.11V300.34a1.11,1.11,0,0,1,1.11-1.11h39.68a1.11,1.11,0,0,1,.88,1.79.9.9,0,0,0-.2.55,1,1,0,0,0,1,.94h216a1,1,0,0,0,1-.94.9.9,0,0,0-.2-.55,1.11,1.11,0,0,1,.88-1.79H386a1.11,1.11,0,0,1,1.11,1.11v29.94A1.11,1.11,0,0,1,386,331.39ZM88.29,329.17H384.87V301.45h-37a.49.49,0,0,1,0,.12,3.21,3.21,0,0,1-3.25,3.16h-216a3.21,3.21,0,0,1-3.25-3.16v-.12h-37Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M386,366.79H87.18a1.11,1.11,0,0,1-1.11-1.11V335.74a1.11,1.11,0,0,1,1.11-1.11h39.69a1.13,1.13,0,0,1,1,.64,1.11,1.11,0,0,1-.16,1.18.8.8,0,0,0-.18.52,1,1,0,0,0,1,.95h216a1,1,0,0,0,1-.95.81.81,0,0,0-.19-.52,1.12,1.12,0,0,1-.15-1.18,1.1,1.1,0,0,1,1-.64H386a1.11,1.11,0,0,1,1.11,1.11v29.94A1.1,1.1,0,0,1,386,366.79ZM88.29,364.57H384.87V336.85h-37a.49.49,0,0,1,0,.12,3.21,3.21,0,0,1-3.25,3.17h-216a3.21,3.21,0,0,1-3.25-3.17v-.12h-37Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M386,296H87.18a1.11,1.11,0,0,1-1.11-1.11V264.94a1.11,1.11,0,0,1,1.11-1.11h39.68a1.09,1.09,0,0,1,1,.63,1.11,1.11,0,0,1-.14,1.17.83.83,0,0,0-.18.53,1,1,0,0,0,1,.95h216a1,1,0,0,0,1-.95.84.84,0,0,0-.19-.53,1.1,1.1,0,0,1,.87-1.8H386a1.1,1.1,0,0,1,1.11,1.11v29.94A1.11,1.11,0,0,1,386,296ZM88.29,293.77H384.87V266.05h-37a.37.37,0,0,1,0,.11,3.22,3.22,0,0,1-3.25,3.17h-216a3.22,3.22,0,0,1-3.25-3.17v-.11h-37Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 70.92,
					y: 243.94,
					width: 327.22,
					height: 10.07,
					transform: "translate(469.05 497.95) rotate(180)",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.92,226.61s-.86,17.33-33.68,17.33-33.68-17.33-33.68-17.33Z",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.92,215.51s-.86,17.33-33.68,17.33-33.68-17.33-33.68-17.33Z",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 398.13,
					y: 243.94,
					width: 35.21,
					height: 10.07,
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 64.4,
					y: 81.69,
					width: 62.24,
					height: 114.43,
					transform: "translate(191.05 277.82) rotate(180)",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 57.31,
					y: 81.69,
					width: 67.64,
					height: 114.43,
					transform: "translate(182.26 277.82) rotate(180)",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 39.58,
					y: 110.75,
					width: 103.1,
					height: 56.31,
					transform: "translate(230.04 47.78) rotate(90)",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M104.84,112.61H77.43c-.3,0-.55.45-.55,1V164.2c0,.56.25,1,.55,1h27.41c.3,0,.54-.45.54-1V113.62C105.38,113.06,105.14,112.61,104.84,112.61ZM78,163.2V114.62l26.32,48.58Z",
					style: { fill: "#f0f0f0" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "freepik--Shadow--inject-2",
			children: /* @__PURE__ */ _jsx("ellipse", {
				id: "freepik--path--inject-2",
				cx: 250,
				cy: 416.24,
				rx: 193.89,
				ry: 11.32,
				style: { fill: "#f5f5f5" }
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Sofa--inject-2",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M154.54,413.82h0a11,11,0,0,0,11-10.95V309a11,11,0,0,0-11-10.95H95V413.82Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M154.54,413.82h0a11,11,0,0,0,11-10.95V309a11,11,0,0,0-11-10.95H95V413.82Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M95,298.07h0A11,11,0,0,0,84,309v104.8h21.9V309A11,11,0,0,0,95,298.07Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M398.05,339.36l3.86-47.86a14.34,14.34,0,0,0-14.47-15.74H193a17.43,17.43,0,0,0-17,15.74l-3.87,47.86A9.7,9.7,0,0,0,181.85,350h204.7A11.79,11.79,0,0,0,398.05,339.36Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M398.05,339.36l3.86-47.86a14.34,14.34,0,0,0-14.47-15.74H193a17.43,17.43,0,0,0-17,15.74l-3.87,47.86A9.7,9.7,0,0,0,181.85,350h204.7A11.79,11.79,0,0,0,398.05,339.36Z",
					style: { opacity: .30000000000000004 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M378.59,339.36l3.86-47.86A14.34,14.34,0,0,0,368,275.76H173.5a17.44,17.44,0,0,0-17,15.74l-3.86,47.86A9.7,9.7,0,0,0,162.4,350H367.1A11.78,11.78,0,0,0,378.59,339.36Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M378.59,339.36l3.86-47.86A14.34,14.34,0,0,0,368,275.76H173.5a17.44,17.44,0,0,0-17,15.74l-3.86,47.86A9.7,9.7,0,0,0,162.4,350H367.1A11.78,11.78,0,0,0,378.59,339.36Z",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M133.19,305s-2.86-2.15-1.83-3.3,5.73,1,5.73,1,26.44-3.33,42-2.73c.11-2.1,2.18-2.91,3.85-2.53s0,3.79,0,3.79,10.91,27.8,10.56,41.84c1.74,1.5,3.48,2.56,1.7,3.28a3.6,3.6,0,0,1-3.37-.62s-35.11,5.14-49.4,2.55c-1,1.9-3,1.53-4.2.94s.79-3.34.79-3.34S130.27,321.61,133.19,305Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M133.19,305s-2.86-2.15-1.83-3.3,5.73,1,5.73,1,26.44-3.33,42-2.73c.11-2.1,2.18-2.91,3.85-2.53s0,3.79,0,3.79,10.91,27.8,10.56,41.84c1.74,1.5,3.48,2.56,1.7,3.28a3.6,3.6,0,0,1-3.37-.62s-35.11,5.14-49.4,2.55c-1,1.9-3,1.53-4.2.94s.79-3.34.79-3.34S130.27,321.61,133.19,305Z",
					style: {
						fill: "#fff",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M371.11,305s2.86-2.15,1.83-3.3-5.72,1-5.72,1-26.45-3.33-42-2.73c-.1-2.1-2.18-2.91-3.85-2.53s0,3.79,0,3.79-10.91,27.8-10.56,41.84c-1.74,1.5-3.47,2.56-1.69,3.28a3.61,3.61,0,0,0,3.37-.62s35.11,5.14,49.39,2.55c1,1.9,3,1.53,4.2.94s-.79-3.34-.79-3.34S374,321.61,371.11,305Z",
					style: {
						fill: "#fff",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M405.05,413.82h0A11,11,0,0,0,416,402.87V309a11,11,0,0,0-10.95-10.95H353.26V413.82Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M405.05,413.82h0A11,11,0,0,0,416,402.87V309a11,11,0,0,0-10.95-10.95H353.26V413.82Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 228.01,
					y: 239.1,
					width: 21.9,
					height: 233.69,
					rx: 6.22,
					transform: "translate(594.91 116.99) rotate(90)",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 219.36,
					y: 277.38,
					width: 46.93,
					height: 225.97,
					rx: 3.32,
					transform: "translate(633.18 147.54) rotate(90)",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 219.36,
					y: 277.38,
					width: 46.93,
					height: 225.97,
					rx: 3.32,
					transform: "translate(633.18 147.54) rotate(90)",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M352.49,366.9H133.16a3.32,3.32,0,0,0-3.32,3.32h226A3.32,3.32,0,0,0,352.49,366.9Z",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M353.26,298.07h0A11,11,0,0,0,342.31,309v104.8h21.9V309A11,11,0,0,0,353.26,298.07Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M392.62,415.85H102.82a2,2,0,0,1-2-2H394.64A2,2,0,0,1,392.62,415.85Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M266.39,273.51c0,1.24,8.3,2.25,18.53,2.25s18.54-1,18.54-2.25Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M274.12,263.83a10.81,10.81,0,1,0,21.61,0Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M273.68,271.91a3.43,3.43,0,1,1,3.42-3.42A3.42,3.42,0,0,1,273.68,271.91Zm0-5.77a2.35,2.35,0,1,0,2.34,2.35A2.35,2.35,0,0,0,273.68,266.14Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M281.94,261.88a3.72,3.72,0,0,1,.25-2.57,9.59,9.59,0,0,0,.87-1.84,3.09,3.09,0,0,0,0-1.45,3.31,3.31,0,0,0-.77-1.26,7.4,7.4,0,0,1-.73-1.06,4.68,4.68,0,0,1-.51-1.53,5.3,5.3,0,0,1,0-1.59,4.13,4.13,0,0,1,.47-1.49,6.22,6.22,0,0,1,1.56-1.69,3.35,3.35,0,0,0,1.05-1.69,3.69,3.69,0,0,1-.25,2.56,9.91,9.91,0,0,0-.87,1.85,3.09,3.09,0,0,0,0,1.45,3.19,3.19,0,0,0,.77,1.26,8.94,8.94,0,0,1,.72,1,4.66,4.66,0,0,1,.51,1.54,5,5,0,0,1-.47,3.08,6,6,0,0,1-1.55,1.68A3.25,3.25,0,0,0,281.94,261.88Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M285.76,251.7a3.58,3.58,0,0,1,.25-2.56,9.91,9.91,0,0,0,.87-1.85,3.09,3.09,0,0,0,0-1.45,3.36,3.36,0,0,0-.78-1.26,7.87,7.87,0,0,1-.72-1.05,4.82,4.82,0,0,1-.51-1.54,5.65,5.65,0,0,1,0-1.59,4.35,4.35,0,0,1,.48-1.49,6.21,6.21,0,0,1,1.55-1.69,3.18,3.18,0,0,0,1.05-1.69,3.62,3.62,0,0,1-.25,2.57,11,11,0,0,0-.87,1.84,3.23,3.23,0,0,0,0,1.45,3.45,3.45,0,0,0,.77,1.26,8.89,8.89,0,0,1,.73,1,4.66,4.66,0,0,1,.51,1.54,5,5,0,0,1-.47,3.08,6,6,0,0,1-1.55,1.68A3.25,3.25,0,0,0,285.76,251.7Z",
					style: { fill: "#e0e0e0" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Character--inject-2",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M329.31,325.92c-5.63,8.17-9.51,8.5-11.22,8.19-3.9-1.55-7.83-3-11.77-4.4-5-1.78-10-3.44-15.06-5s-10.15-3.11-15.33-4.46c-2.61-.67-5.22-1.33-7.9-1.93-1.3-.33-2.73-.56-4.1-.83-.67-.14-1.41-.24-2.16-.35l-2.24-.31-.18,0-.88,0c-5.06.12-10.12.22-15.17.42l-7.58.25-7.58.34c-5,.2-10.09.5-15.14.79s-10.09.65-15.13,1.1l1,16.62c5.06-.16,10.12-.44,15.18-.74s10.11-.64,15.16-1l7.58-.59,7.57-.66c4.91-.41,9.81-.9,14.72-1.38l1,.07c.56,0,1.12.07,1.74.15,1.22.16,2.4.25,3.67.44,2.49.32,5,.72,7.56,1.13,5.08.86,10.22,1.71,15.35,2.64l15.46,2.73c4.39.75,8.78,1.5,13.19,2.19,1.24,1.07,2.57,2.46,3,2.84,1.3,1.05,2.92,1.48,3.62-.14s.93-3.46,2.15-6.45c.74-1.83,3.69-6.93,4.72-9.47S330,325,329.31,325.92Z",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M329.31,325.92c-5.63,8.17-9.51,8.5-11.22,8.19-3.9-1.55-7.83-3-11.77-4.4-5-1.78-10-3.44-15.06-5s-10.15-3.11-15.33-4.46c-2.61-.67-5.22-1.33-7.9-1.93-1.3-.33-2.73-.56-4.1-.83-.67-.14-1.41-.24-2.16-.35l-2.24-.31-.18,0-.88,0c-5.06.12-10.12.22-15.17.42l-7.58.25-7.58.34c-5,.2-10.09.5-15.14.79s-10.09.65-15.13,1.1l1,16.62c5.06-.16,10.12-.44,15.18-.74s10.11-.64,15.16-1l7.58-.59,7.57-.66c4.91-.41,9.81-.9,14.72-1.38l1,.07c.56,0,1.12.07,1.74.15,1.22.16,2.4.26,3.67.44,2.49.32,5,.72,7.56,1.13,5.08.86,10.22,1.71,15.35,2.64l15.46,2.73c4.39.75,8.78,1.5,13.19,2.19,1.24,1.07,2.57,2.46,3,2.84,1.3,1.05,2.92,1.48,3.62-.14s.93-3.46,2.15-6.45c.74-1.83,3.69-6.93,4.72-9.47S330,325,329.31,325.92Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M200.58,278.43c.2,1,.5,2.18.77,3.28s.59,2.23.92,3.33c.67,2.21,1.42,4.38,2.25,6.47a38.92,38.92,0,0,0,2.92,5.89,18.61,18.61,0,0,0,3.71,4.53,6.78,6.78,0,0,0,4.14,1.74,8.36,8.36,0,0,0,2.32-.32,7,7,0,0,0,2.14-1,10.45,10.45,0,0,0,3.38-4.21,20.6,20.6,0,0,0,1.1-3A28,28,0,0,0,225,292l0-.24a2.14,2.14,0,0,1,4.22.08,21.32,21.32,0,0,1,.2,4.11,21.07,21.07,0,0,1-.58,4.12,15.37,15.37,0,0,1-4.48,7.87,13.4,13.4,0,0,1-4.18,2.62,14,14,0,0,1-4.82,1,13.53,13.53,0,0,1-5.05-.82,16,16,0,0,1-4.26-2.36,25.17,25.17,0,0,1-5.78-6.48,49.15,49.15,0,0,1-3.71-7.1,62.44,62.44,0,0,1-2.62-7.3c-.37-1.23-.71-2.46-1-3.7s-.57-2.46-.83-3.85a4.31,4.31,0,0,1,8.47-1.64Z",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M195.16,325.2c9.48,1,19.15,2,28.67,2.91,4.77.42,9.53.83,14.25,1.11q3.54.19,7,.34l3.45.05,1.37,0a12.62,12.62,0,0,1,2.33.3,11.09,11.09,0,0,1,4.9,2.48,11.65,11.65,0,0,1,2.9,3.95,14.16,14.16,0,0,1,1.05,3.43,23,23,0,0,1,.24,5.3,50.15,50.15,0,0,1-1.39,8.42A116.07,116.07,0,0,1,255,368.16q-1.42,3.49-3,6.92t-3.22,6.75c-2.25,4.46-4.55,8.82-7.16,13.12l-5.92-2.7c2.84-9.26,5.7-18.59,8.08-27.79a132.71,132.71,0,0,0,2.84-13.61,33.82,33.82,0,0,0,.44-6.11,7.63,7.63,0,0,0-.28-2c-.07-.17-.13-.23-.08-.05a2.72,2.72,0,0,0,.74,1,3.91,3.91,0,0,0,1.64.9,3.14,3.14,0,0,0,.51.1h0l-.49,0-3.88.24-3.82.15c-1.28.05-2.54,0-3.81,0-5.05,0-10.06-.11-15-.41-10-.57-19.77-1.51-29.68-3.07Z",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M231.78,395c.65-.57,3.74-2.64,4.67-3.87s3.45,2.8,3.68,2.94c1.07,1,2.11-.14,1.94.23-.63,1.39-1.58,5.32,6.13,12.75.84.81,0,2.3-2.28.9s-6.89-5.16-8.58-6.2c-2.75-1.68-4.41-2.12-6-3.16S230.53,396.15,231.78,395Z",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M157.3,273.06a4.41,4.41,0,0,0-3.75,4.47c.38,16.79,1,41.72,14.71,55.51,4.6,4.62,7.12,6.6,11.28,7.77a171,171,0,0,0,17.18-32.25c-2.19-1.1-3.64-4.95-3.64-8.6,0-8,2.34-16.94,3.85-21.89a3.66,3.66,0,0,0-2.84-4.67c-2.26-.41-5.27-.89-8.61-1.25a115.22,115.22,0,0,0-16.53-.24A101.25,101.25,0,0,0,157.3,273.06Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M157.3,273.06a4.41,4.41,0,0,0-3.75,4.47c.38,16.79,1,41.72,14.71,55.51,4.6,4.62,7.12,6.6,11.28,7.77a171,171,0,0,0,17.18-32.25c-2.19-1.1-3.64-4.95-3.64-8.6,0-8,2.34-16.94,3.85-21.89a3.66,3.66,0,0,0-2.84-4.67c-2.26-.41-5.27-.89-8.61-1.25a115.22,115.22,0,0,0-16.53-.24A101.25,101.25,0,0,0,157.3,273.06Z",
					style: { opacity: .5 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.66,282c.24,8.38.77,18.16,2.88,27.4,2.79-10.55,3-29.11,3-29.11Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M196.72,308.56s12.59,4.73,37.61,6.58l-1.75,24.21c-13,8.15-46.56,4-49.75-4.59Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M210,321.28l23.68,2.92.33-4.58C228.68,320.68,210,321.28,210,321.28Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192.67,316.2a288.2,288.2,0,0,0,45,7.35L237.49,351c-19.28,5.36-54.76-1.61-58-10.19Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M160,279.91c-1.62,5.72-3.18,11.6-4.53,17.42-.67,2.92-1.25,5.84-1.79,8.74a68.89,68.89,0,0,0-1,8.56c0,.68,0,1.35,0,2a4.23,4.23,0,0,0,.12,1c.06.12-.08,0-.21-.07s0,.07.33.09a9.46,9.46,0,0,0,3.2-.6,32,32,0,0,0,3.82-1.59,77.49,77.49,0,0,0,7.7-4.3c2.53-1.57,5.06-3.26,7.5-4.95l0,0a2.14,2.14,0,0,1,2.72,3.29,87.74,87.74,0,0,1-14.81,11.8,40.64,40.64,0,0,1-4.46,2.33,15.88,15.88,0,0,1-5.71,1.41,7.94,7.94,0,0,1-4.08-.93,7.17,7.17,0,0,1-3.12-3.5,10.91,10.91,0,0,1-.8-3.48c-.06-.88-.09-1.74-.1-2.59a76,76,0,0,1,.74-9.69c.41-3.15,1-6.23,1.63-9.29,1.26-6.13,2.78-12.09,4.62-18.1a4.31,4.31,0,0,1,8.27,2.43Z",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M164.39,226.32c-2.69-2.15-8.7-6.51-4.49-10.79s16.3-.39,17.61,3.69C180.63,228.89,171.16,231.73,164.39,226.32Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M164.55,219.12c-1.23-3.1-4.17-9.62,1.1-12s13.31,6.06,12.59,10.46C176.52,228,167.64,226.94,164.55,219.12Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M171.15,216c1-3,3-9.47,8-7.32s5.22,13.61,2.08,16.06C173.78,230.56,168.49,223.51,171.15,216Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M175.31,233.58c-2.9,1-7,.51-7.21-4.7s4.87-8.83,10.36-8.55C186.64,220.74,182.63,231.09,175.31,233.58Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M170.86,253.31c1,5.34,1.86,15.1-1.91,18.6,0,0,6.9,7.21,13.74,7.31s2.79-7.07,2.79-7.07c-5.91-1.5-5.69-5.9-4.6-10Z",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M169.93,246.5c-4.67-4.66-7.85-13.5,1.29-20.44s24.13,2.53,25.74,10.45C199.23,247.74,181.72,258.26,169.93,246.5Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M174.94,256.91l5.94,5.21a17.17,17.17,0,0,0-.56,2.93c-2.26-.36-5.64-2.44-5.85-4.82A9.64,9.64,0,0,1,174.94,256.91Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M171.69,239.79c-1.66,8.75-2.55,12.41.68,17.93,4.85,8.31,15.95,8.44,20.19.37,3.81-7.27,5.89-20.34-1.67-25.91A12.14,12.14,0,0,0,171.69,239.79Z",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M169,243.15c1.18,4.35,13.46-1.31,15.35-8,2.71,4.28,12.51,7.1,11.73,2.37s-7-11.18-14.56-9.8S167,235.6,169,243.15Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M168,246.78a6.52,6.52,0,0,0,2.21,4.45c1.73,1.48,3.55.16,3.88-2,.29-1.92-.26-5-2.38-5.68A2.92,2.92,0,0,0,168,246.78Z",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M183.87,246.76c-.18.7,0,1.36.5,1.48s1-.36,1.16-1.06-.05-1.37-.51-1.48S184,246.06,183.87,246.76Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M191.79,248.77c-.18.7.05,1.36.51,1.48s1-.36,1.15-1.06,0-1.36-.51-1.48S192,248.07,191.79,248.77Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192.73,247.7l1.81-.06S193.34,248.74,192.73,247.7Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M188.85,248.85a20.59,20.59,0,0,0,2.34,5,3.14,3.14,0,0,1-2.59.42Z",
					style: { fill: "#ed847e" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M185,256.49a.2.2,0,0,0,.2-.13.19.19,0,0,0-.13-.22,5.77,5.77,0,0,1-4-3.34.17.17,0,0,0-.23-.11.18.18,0,0,0-.11.22,6,6,0,0,0,4.25,3.57Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M182.36,243.12a.34.34,0,0,0,.24-.05,3.44,3.44,0,0,1,3.11-.44.35.35,0,0,0,.46-.19A.35.35,0,0,0,186,242a4.14,4.14,0,0,0-3.78.5.35.35,0,0,0-.1.49A.37.37,0,0,0,182.36,243.12Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M196.47,246.38a.35.35,0,0,0,.34-.55,4.14,4.14,0,0,0-3.34-1.83.36.36,0,0,0-.34.37.35.35,0,0,0,.37.34,3.45,3.45,0,0,1,2.74,1.53A.31.31,0,0,0,196.47,246.38Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.81,245.69l1.8-.06S185.41,246.72,184.81,245.69Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M208.08,283s-3.13-3-9.68-2.22-9-1.06-9-1.06l-3.77,1.83-6.49,35.39,22.23,2.33Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M208.08,283s2.33-4.33,8.44-3.64,7.85-2.1,7.85-2.1l3.1,1.83L221,314.45l-19.55,4.79Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M199.32,320.59l-20.53-2.33a1,1,0,0,1-1-1.17l6.39-34.8a1.47,1.47,0,0,1,1.38-1.17l20.54,2.33a.35.35,0,0,1,.35.42l-6.67,36.3A.52.52,0,0,1,199.32,320.59Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M199.32,320.59l-20.53-2.33a1,1,0,0,1-1-1.17l6.39-34.8a1.47,1.47,0,0,1,1.38-1.17l20.54,2.33a.35.35,0,0,1,.35.42l-6.67,36.3A.52.52,0,0,1,199.32,320.59Z",
					style: {
						fill: "#fff",
						opacity: .1
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M203,320.59l17.86-4.79a1.48,1.48,0,0,0,1.38-1.17l6.39-34.8a1,1,0,0,0-1-1.18l-17.86,4.8a.52.52,0,0,0-.5.42l-6.67,36.3A.34.34,0,0,0,203,320.59Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M203,320.59l17.86-4.79a1.48,1.48,0,0,0,1.38-1.17l6.39-34.8a1,1,0,0,0-1-1.18l-17.86,4.8a.52.52,0,0,0-.5.42l-6.67,36.3A.34.34,0,0,0,203,320.59Z",
					style: {
						fill: "#fff",
						opacity: .1
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M202.2,320.59h-2.06a.31.31,0,0,1-.32-.39l6.67-36.36a.49.49,0,0,1,.47-.39H209a.31.31,0,0,1,.32.39l-6.67,36.36A.49.49,0,0,1,202.2,320.59Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M202.2,320.59h-2.06a.31.31,0,0,1-.32-.39l6.67-36.36a.49.49,0,0,1,.47-.39H209a.31.31,0,0,1,.32.39l-6.67,36.36A.49.49,0,0,1,202.2,320.59Z",
					style: {
						fill: "#fff",
						opacity: .30000000000000004
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M175.93,309.79l7.86-1.39-2.64-7s-5.14,3.24-6.86,6.12Z",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "188.05 306.73 187.58 299.47 181.15 301.42 183.79 308.4 188.05 306.73",
					style: { fill: "#ffc3bd" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "230.04 293.22 229.6 284.1 223.5 283.71 225.99 293.42 230.04 293.22",
					style: { fill: "#ffc3bd" }
				})
			]
		})
	]
});
export default SvgNoPendingSubject;
